import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M4.17285 20.695H6.78085V9.39099H4.17285V20.695Z',
                    fill: '#5877A6',
                },
            },
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M8.521 20.695H11.13V9.39099H8.521V20.695Z',
                    fill: '#5877A6',
                },
            },
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M12.8691 20.695H15.4771V9.39099H12.8691V20.695Z',
                    fill: '#5877A6',
                },
            },
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M17.2168 20.695H19.8258V9.39099H17.2168V20.695Z',
                    fill: '#5877A6',
                },
            },
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M4.17285 11.9989H6.78085V10.6949H4.17285V11.9989Z',
                    fill: '#43618B',
                },
            },
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M8.521 11.9989H11.13V10.6949H8.521V11.9989Z',
                    fill: '#43618B',
                },
            },
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M12.8691 11.9989H15.4771V10.6949H12.8691V11.9989Z',
                    fill: '#43618B',
                },
            },
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M17.2168 11.9989H19.8258V10.6949H17.2168V11.9989Z',
                    fill: '#43618B',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M11.791 2.052L2.227 7.27C2.086 7.346 2 7.492 2 7.651V10.26C2 10.501 2.194 10.695 2.434 10.695H21.565C21.805 10.695 22 10.501 22 10.26V7.651C22 7.492 21.912 7.346 21.773 7.27L12.208 2.052C12.143 2.017 12.071 2 12 2C11.928 2 11.856 2.017 11.791 2.052Z',
                    fill: '#C9DEF2',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M10.2598 6.78197C10.2598 7.74197 11.0388 8.52197 11.9998 8.52197C12.9598 8.52197 13.7378 7.74197 13.7378 6.78197C13.7378 5.82197 12.9598 5.04297 11.9998 5.04297C11.0388 5.04297 10.2598 5.82197 10.2598 6.78197Z',
                    fill: 'white',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M2.434 19.391C2.194 19.391 2 19.585 2 19.826V20.695C2 20.935 2.194 21.13 2.434 21.13H21.565C21.805 21.13 22 20.935 22 20.695V19.826C22 19.585 21.805 19.391 21.565 19.391H2.434Z',
                    fill: '#C9DEF2',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const BankColored = React.forwardRef(IconComponent);
BankColored.displayName = 'BankColored';

export { BankColored };
